export const normalizeGroup = (group: string) => group.trim().toLocaleLowerCase('ru-RU');

export const hasAnyGroup = (
  groups: readonly string[] | undefined,
  requiredGroups: readonly string[],
) => {
  const normalizedGroups = new Set((groups ?? []).map(normalizeGroup));
  return requiredGroups.some((group) => normalizedGroups.has(normalizeGroup(group)));
};
